import React, { useState } from 'react';
import { Play, ThumbsUp, MessageSquare, Eye } from 'lucide-react';



interface CardProps {
  video: any;
  onSelectVideo: (video: any) => void;
}

// Função para calcular o "tempo atrás" (estilo YouTube)
const formatTimeAgo = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return 'há poucos segundos';
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `há ${diffInMinutes} minuto${diffInMinutes > 1 ? 's' : ''}`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `há ${diffInHours} hora${diffInHours > 1 ? 's' : ''}`;
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) return `há ${diffInDays} dia${diffInDays > 1 ? 's' : ''}`;
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) return `há ${diffInMonths} mês${diffInMonths > 1 ? 'es' : ''}`;
  const diffInYears = Math.floor(diffInDays / 365);
  return `há ${diffInYears} ano${diffInYears > 1 ? 's' : ''}`;
};

export default function PlayFeedVideoCard({ video, onSelectVideo }: CardProps) {
  const [isHovered, setIsHovered] = useState(false);

  // Cor padrão se o vídeo não tiver uma cor definida
  const cardColor = video.color || '#E50914';

  return (
    <div
      onClick={() => onSelectVideo(video)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: '#0a0a0a',
        borderRadius: '12px',
        cursor: 'pointer',
        overflow: 'hidden',
        border: isHovered ? `1px solid ${cardColor}` : '1px solid rgba(255,255,255,0.06)',
        transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        transform: isHovered ? 'translateY(-6px) scale(1.02)' : 'translateY(0) scale(1)',
        boxShadow: isHovered ? `0 20px 30px -10px ${cardColor}50` : '0 10px 20px -10px rgba(0,0,0,0.7)',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Capa do Vídeo (16:9) com o fundo cinza elegante */}
      <div style={{ 
        position: 'relative', 
        width: '100%', 
        aspectRatio: '16/9', 
        backgroundColor: '#1c1c1c', 
        overflow: 'hidden' 
      }}>
        <img 
          src={video.thumbnail || video.thumb || video.thumbnail_url || 'https://picsum.photos/seed/error/640/360'} 
          alt={video.title} 
          style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} 
        />
        
        {/* Ícone de Play centralizado que aparece no Hover */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundColor: isHovered ? 'rgba(0,0,0,0.4)' : 'transparent',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background-color 0.3s'
        }}>
          <div style={{
            width: '45px', height: '45px', borderRadius: '50%', backgroundColor: cardColor,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            opacity: isHovered ? 1 : 0, transform: isHovered ? 'scale(1)' : 'scale(0.6)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: `0 0 15px ${cardColor}`
          }}>
            <Play size={20} color="#fff" fill="#fff" style={{ marginLeft: '2px' }} />
          </div>
        </div>
      </div>

      {/* Informações do Vídeo */}
      <div style={{ padding: '14px', display: 'flex', flexDirection: 'column', gap: '6px', flex: 1 }}>
        <h3 style={{ 
          color: '#fff', margin: 0, fontSize: '14px', fontWeight: '600', 
          lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: 2, 
          WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' 
        }}>
          {video.title}
        </h3>
        {/* Informações da Base e Ícones */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', paddingTop: '8px' }}>
          
          <span style={{ color: '#888', fontSize: '11px' }}>
            {formatTimeAgo(video.created_at)}
          </span>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {/* Visualizações */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#888', fontSize: '12px' }}>
              <Eye size={13} /> {video.views_count || 0}
            </div>

            {/* Curtidas */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#888', fontSize: '12px' }}>
              <ThumbsUp size={13} /> {video.likes_count || 0}
            </div>

            {/* Comentários */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#888', fontSize: '12px' }}>
              <MessageSquare size={13} /> {video.comments_count || 0}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}